import { useCallback } from "react";
import { isString } from "lodash";

function useBuildSearchParams() {
  return useCallback((urlParams) => {
    const removeInvalidPair = (param) => {
      if (!Array.isArray(param) || param.length !== 2) return false;

      return isString(param[0]) && param[0] && isString(param[1]) && param[1];
    };

    return new URLSearchParams(urlParams.filter(removeInvalidPair));
  }, []);
}

export default useBuildSearchParams;
